import styled from 'styled-components';
import { Button as ButtonBase } from '@material-ui/core';

export const Button = styled(ButtonBase)`
  ${({ marginleft }) => marginleft && `margin-left: ${marginleft}px`}
  ${({ marginright }) => marginright && `margin-left: ${marginright}px`}
  ${({ margintop }) => margintop && `margin-left: ${margintop}px`}
  ${({ marginbottom }) => marginbottom && `margin-left: ${marginbottom}px`}
`;

export default Button;
